import { gql } from '@apollo/client';

export const GetCompletedOnboardingStepsForDashboardShell = gql`
  query GetCompletedOnboardingStepsForDashboardShell {
    getCompletedOnboardingStepsForOrg
  }
`;
